import { render, staticRenderFns } from "./ConfirmInvitation.vue?vue&type=template&id=529c812f&scoped=true&"
import script from "./ConfirmInvitation.vue?vue&type=script&lang=js&"
export * from "./ConfirmInvitation.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmInvitation.vue?vue&type=style&index=0&id=529c812f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c812f",
  null
  
)

export default component.exports